import api from "../../axiosconfig";

/**
 * Fetch all live events for developer portal
 */
export const fetchAdminLiveEvents = async () => {
  const response = await api.get("/api/live-events/admin/all");
  return response.data;
};

/**
 * Create a new live event
 */
export const createAdminLiveEvent = async (eventData) => {
  const response = await api.post("/api/live-events/admin", eventData);
  return response.data;
};

/**
 * Update an existing live event
 * @param {number|string} eventId - Live event ID
 * @param {Object} eventData - Updated event fields
 * @param {boolean} notify - Whether to send update emails to registered users
 */
export const updateAdminLiveEvent = async (eventId, eventData, notify = false) => {
  const response = await api.put(`/api/live-events/admin/${eventId}`, eventData, {
    params: { notify: Boolean(notify) },
  });
  return response.data;
};

/**
 * Delete a live event
 * @param {number|string} eventId - Live event ID
 * @param {boolean} notify - Whether to send cancellation emails to registered users
 */
export const deleteAdminLiveEvent = async (eventId, notify = false) => {
  const response = await api.delete(`/api/live-events/admin/${eventId}`, {
    params: { notify: Boolean(notify) },
  });
  return response.data;
};

/**
 * Fetch attendees for a live event
 */
export const fetchLiveEventAttendees = async (eventId) => {
  const response = await api.get(`/api/live-events/admin/${eventId}/attendees`);
  return response.data;
};

/**
 * Delete / Remove a registered user from an event
 */
export const deleteLiveEventAttendee = async (eventId, userId) => {
  const response = await api.delete(`/api/live-events/admin/${eventId}/attendees/${userId}`);
  return response.data;
};

/**
 * Send attendee roster to designated email
 */
export const sendLiveEventAttendeesEmail = async (eventId, recipientEmail) => {
  const response = await api.post(`/api/live-events/admin/${eventId}/send-attendee-list`, {
    recipient_email: recipientEmail,
  });
  return response.data;
};
